'use client'

/**
 * Thin storefront wrapper around shared-ui's ContactCtaSection that wires the
 * analytics onCtaClick callback. Lives in the storefront (not shared-ui) to
 * keep the dependency direction clean: shared-ui has no analytics import; the
 * storefront glues them — same pattern as AnalyticsPopupHost / AnalyticsSiteHeader.
 *
 * Required because ContentSections renders server-side and `track` is a
 * browser-only, consent-gated client function. Emits section_cta_click +
 * contact_start on the email/phone CTA. Fire-and-forget; never preventDefault.
 */

import { ContactCtaSection, type ContactCtaSectionProps } from '@sifly/shared-ui/content'
import { track } from '@/lib/analytics'

export function AnalyticsContactCta(props: Omit<ContactCtaSectionProps, 'onCtaClick'>) {
  return (
    <ContactCtaSection
      {...props}
      onCtaClick={({ channel, label, href }) => {
        track('section_cta_click', { kind: 'contact_cta', channel, label, href })
        track('contact_start', { channel, label, href })
      }}
    />
  )
}
